<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color:white">
            <br>
            <h3 style="text-align: center">เพิ่มโปรโมชั่นอื่นๆ</h3>
            <br/>
            <div class="form-group row">
                <label class="col-sm-4 col-form-label text-capitalize text-right">
                    ชื่อโปรโมชั่น
                </label>
                <div class="col-sm-6">
                    <input class="form-control" v-model="form.name"/>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-4 col-form-label text-capitalize text-right">
                    เซลล์
                </label>
                <div class="col-sm-6">
                    <multiselect
                            v-model="form.sales"
                            :options="sellers"
                            track-by="id"
                            :multiple="true"
                            label="name"
                            :show-labels="false"
                            placeholder="เลือกเซลล์">
                    </multiselect>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-4 col-form-label text-capitalize text-right">
                    สถานะ
                </label>
                <div class="col-sm-6">
                    <b-form-select :options="status_promotion" v-model="form.active"></b-form-select>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-4 col-form-label text-capitalize text-right">
                    ส่วนลดเบ็ดเตล็ดและประเภทอื่นๆ
                </label>
                <div class="col-sm-3">
                    <input type="number" class="form-control" v-model="form.max_discount"/>
                </div>
                <label class="col-sm-3">บาท</label>
            </div>
            <br>
            <div>
                <div class="row" style="margin-left: 150px">
                    <b-col class="col-sm-3 text-right">
                        เลือกสินค้าสำหรับโปรโมชั่น
                    </b-col>
                    <b-col class="col-sm-8 form-inline">
                        <input type="text" class="form-control"
                               placeholder="รหัสสินค้า" v-model="search_product.code"/>&nbsp;
                        <b-form-select :options="optionProductType" v-model="search_product.type"></b-form-select>&nbsp;
                        <button class="btn btn-primary" @click="searchProduct">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                    </b-col>
                </div>
                <div class="row">
                    <b-col class="col text-center">
                        <table class="table table-bordered text-center">
                            <thead>
                            <tr>
                                <th><input type="checkbox" v-model="selectAll"/></th>
                                <th>รหัสสินค้า</th>
                                <th>ชื่อสินค้า</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="data in products">
                                <td><input type="checkbox" v-model="form.products"
                                           :value="data"/></td>
                                <td>{{data.sku}}</td>
                                <td>{{data.name}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                </div>
                <div v-if="products.length > 0">
                    <vue-pagination :pagination="dataPaginate" @paginate="getProductsPage">
                    </vue-pagination>
                </div>
            </div>
            <div class="row">
                <div class="col text-center">
                    <button
                            type="button"
                            @click="savePromotionOther"
                            class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon> บันทึก</button>
                    &nbsp&nbsp
                    <button @click="goToPromotionsOtherList"
                            type="button"
                            class="btn btn-outline-secondary">
                        <icon name="times" style="width: 25px"></icon> ยกเลิก
                    </button>
                    &nbsp&nbsp
                    <button type="button"
                            v-if="form.id"
                            @click="showDeleteModal"
                            class="btn btn-danger">
                        <icon name="trash" style="width: 25px"></icon> ลบ
                    </button>
                </div>
            </div>
            <br>
            <div style="margin-bottom: 20px; padding-left: 20px">
                <table class="table table-bordered" style="width: 500px;">
                    <tr>
                        <th>ลำดับ</th>
                        <th>รายการสินค้าที่เลือก</th>
                    </tr>
                    <tr v-for="(data,index) in form.products">
                        <td>{{++index}}</td>
                        <td>{{data.sku}}</td>
                    </tr>
                </table>
            </div>
            <!--<pre class="alert-primary">{{form}}</pre>-->
        </div>
        <!-- ---delete---- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button @click="deletePromotionOther"
                        type="button"
                        class="btn btn-success">ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-secondary">ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert-warning">{{products.length}}</pre>-->
        <!--<pre class="alert-warning">{{form.products}}</pre>-->
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import { mapState } from "vuex";
    import DatePicker from 'vue2-datepicker'
    import VuePagination from "../../Pagination";
    import moment from "moment";

    export default {
        name: "promotion-other-form",
        components:{
            VuePagination,
            Multiselect,
            DatePicker
        },
        created(){
            this.$store.dispatch("Seller/get");
            this.getProductsPage();
            this.$store.dispatch('ProductType/get');
            this.$store.dispatch('PromotionOther/clearData');
        },
        data(){
          return{
              status_promotion : [
                  {value:0 , text: "InActive"},
                  {value:1 , text: "Active"}
              ],
              items: [
                  {
                      text: "รายการโปรโมชั่นอื่นๆ",
                      to: {name: "promotions-other-list"}
                  },
                  {
                      text: "เพิ่มเติม",
                      active: true
                  }
              ],
              search_product:{
                  code : "",
                  type : ""
              },
              event_submit : false,
              products : [],
              dataPaginate:{
                  current_page :1,
                  from : 1,
                  last_page : 1,
                  per_page : 1,
                  total : 1,
                  to : 1
              },
          }
        },
        computed:{
            ...mapState({
                sellers:state=>{
                    return state.Seller.data;
                },
                optionProductType : state =>{
                    return [
                        {
                            value: "",
                            text: "หมวดหมู่สินค้า"
                        },
                        ...state.ProductType.data.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
                form:state=>{
                    return state.PromotionOther.form;
                }
            }),
            selectAll:{
                get:function () {
                    return this.products ? this.form.products.length >= this.products.length : false;
                },
                set:function (value) {
                    if(value){
                        this.select_all = true;
                        this.$store.dispatch("Promotion/selectAllProducts",{
                            code: this.search_product.code,
                            type: this.search_product.type
                        }).then(data=>{
                            this.form.products = data;
                        })
                    }
                    else{
                        this.select_all = false;
                        this.form.products = [];
                    }
                }
            },
        },
        methods:{
            //modal
            showDeleteModal() {
                this.$refs.delete_item.show();
            },
            hideDeleteModal() {
                this.$refs.delete_item.hide();
            },
            //api
            getProductsPage(){
                const page = this.dataPaginate.current_page;
                if(this.event_submit){
                    this.searchProduct(page);
                }
                else{
                    this.$store.dispatch('Products/setProducts',page).then(res=>{
                        this.products = res.data;
                        this.dataPaginate = {
                            current_page : res.current_page,
                            from : res.form,
                            last_page : res.last_page,
                            per_page : res.per_page,
                            total : res.total,
                            to : res.to
                        }

                    })
                }
            },
            savePromotionOther(){
                let sale_id = [];
                if(this.form.sales.length > 0){
                    this.form.sales.forEach(sale=>{
                        sale_id.push(sale.id);
                    });
                }
                if(this.form.products.length > 0){
                    this.form.product_id = [];
                    this.form.products.forEach(product=>{
                        this.form.product_id.push(product.id);
                    })
                }
                let data = {
                    sale_id : sale_id.toString(),
                    product_id : this.form.product_id.toString(),
                    name : this.form.name,
                    active : this.form.active,
                    max_discount : this.form.max_discount
                };
                this.$store.dispatch('PromotionOther/savePromotionOther',{
                    id : this.form.id,
                    data : data
                });
                this.goToPromotionsOtherList();
            },
            goToPromotionsOtherList(){
                this.$router.push("/promotions-other");
            },
            deletePromotionOther(){
                this.$store.dispatch("PromotionOther/deletePromotionOther",this.form.id).then(()=>{
                    this.goToPromotionsOtherList();
                })
            },
            searchProduct(page = 1) {
                this.event_submit = true;
                this.form.product_id = [];
                if (this.search_product.type === null) {
                    this.search_product.type = "";
                }
                this.$store.dispatch("Products/search", {
                    page:page,
                    code: this.search_product.code,
                    type: this.search_product.type
                }).then(res=>{
                    this.products = res.data;
                    this.dataPaginate = {
                        current_page : res.current_page,
                        from : res.form,
                        last_page : res.last_page,
                        per_page : res.per_page,
                        total : res.total,
                        to : res.to
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
